import Link from "next/link";

/** Prev / "Page x of y" / Next. Plain links, so the first page of every view is crawlable. */
export default function Pager({
  current,
  totalPages,
  hrefFor,
  labelled = true,
}: {
  current: number;
  totalPages: number;
  hrefFor: (page: number) => string;
  labelled?: boolean;
}) {
  if (totalPages <= 1) return null;
  return (
    <nav
      aria-label={labelled ? "Pagination" : undefined}
      className="mt-16 flex items-center justify-center gap-6 text-[12px] uppercase tracking-[0.15em]"
    >
      {current > 1 ? (
        <Link href={hrefFor(current - 1)} className="hover:text-gold-deep">← Prev</Link>
      ) : (
        <span aria-disabled="true" className="text-ink/60">← Prev</span>
      )}
      <span className="text-ink/60">Page {current} of {totalPages}</span>
      {current < totalPages ? (
        <Link href={hrefFor(current + 1)} className="hover:text-gold-deep">Next →</Link>
      ) : (
        <span aria-disabled="true" className="text-ink/60">Next →</span>
      )}
    </nav>
  );
}
